module.exports = __webpack_public_path__ + "img/nav_logo_h.b40f27e9.png";